import { TASK_STATUS_BY_NAME_QUERY } from "../constants/graphql";
export default {
  data() {
    return {
      propagateTaskPolling: false,
      propagateTaskContinuous: false, // set to true in a component to enable continuous polling
    };
  },

  apollo: {
    propagateTaskStatus: {
      query: TASK_STATUS_BY_NAME_QUERY,
      variables() {
        return { name: "propagate_owner_access_settings" };
      },
      result({ data }) {
        this.propagateTaskPolling = false;
        const status = data && data.taskStatus ? data.taskStatus.status : null;
        if (status === "IN_PROGRESS") {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Access settings are being propagated to all users...",
            color: "info",
          });
          if (this.propagateTaskContinuous) {
            setTimeout(() => {
              this.propagateTaskPolling = true;
            }, 3000);
          }
        } else if (status === "FINISHED") {
          if (this.propagateTaskContinuous) {
            this.$store.dispatch("showAppSnackbar", {
              msg: "Access settings update complete.",
              color: "success",
            });
          }
        } else if (status === "ERROR") {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Access settings update failed.",
            color: "error",
          });
        }
      },
      skip() {
        return !this.propagateTaskPolling;
      },
      fetchPolicy: "network-only",
    },
  },

  mounted() {
    this.propagateTaskPolling = true;
  },

  beforeDestroy() {
    this.propagateTaskPolling = false;
  },
};



// WEBPACK FOOTER //
// ./src/mixins/PropagateAccessTaskMixin.js